export default __webpack_public_path__ + "static/media/Learning Launchpad.aaac0c0d.png";